module.exports = __webpack_public_path__ + "img/receipt_ai_helper.f69e260d.png";